<div class="site-card">
  <h3>{{mainHeader}}</h3>
  <p>{{subHeader}}</p>
  <div class="">
    <site-select [displayNone]="isDisplayNone" (siteCahnge)="siteCahngeInnerComponent()" (siteInit)="siteInitInnerComponent()"></site-select>
  </div>
</div>
